























  import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

  import Icon, { IconEnum } from '@/shared/components/icon.component.vue';

  export enum TableColumnOrderColor {
      Primary = 'table-column-order--primary',
      Secondary = 'table-column-order--secondary',
  }

  @Component({
      components: {
          Icon,
      },
  })

export default class TableColumnOrder extends Vue {
  @Prop() private columnLabel!: string;
  @Prop() private columnDbName!: string;
  @Prop( { default: true } ) private keepIcon!: false;
  @Prop( { default: 0 } ) private orderDirection!: number;
  @Prop( { default: TableColumnOrderColor.Primary } ) private color!: TableColumnOrderColor;
  @Prop( { default: false } ) private isActive!: boolean;

  private iconEnum = IconEnum;

  get textActive() {
      return this.orderDirection !== 0 || this.isActive;
  }

  private emitOrder() {
      let newOrderDirection;
      if ( this.orderDirection === 0 ) {
          newOrderDirection = 1;
      } else if ( this.orderDirection === 1 ) {
          newOrderDirection = -1;
      } else if ( this.orderDirection === -1 ) {
          newOrderDirection = 0;
      }
      this.$emit( 'table-column-order-change', this.columnDbName, newOrderDirection );
  }
}
